export default "/images/Medscape.svg?968a0b022aad65c453e054c686f4a796";